<script setup>
import { reactive } from 'vue'
import axios from 'axios'
import Swal from 'sweetalert2'

const props = defineProps({
  isDisabledButton: {
    type: Boolean,
    required: true
  },
  importParams: {
    type: Object,
    required: true
  },
  department: {
    type: Object,
    required: true
  },
  creatorReservations: {
    type: Array,
    required: true
  }
})
const data = reactive({
  isLoading: false
})

const submit = async () => {
  const modal = await Swal.fire({
    title: '更新してもよろしいですか？',
    text: '',
    confirmButtonText: 'はい',
    confirmButtonColor: '#40BF6C',
    cancelButtonText: 'キャンセル',
    showCancelButton: true,
    reverseButtons: true,
    focusCancel: true
  })
  if (modal.isConfirmed) {
    data.isLoading = true
    try {
      await axios.put(`/departments/${props.department.id}/reservations`, {
        creator_reservations: props.creatorReservations,
        import_params: props.importParams
      })
      data.isLoading = false
      await Swal.fire({
        icon: 'success',
        title: '更新が完了しました',
        text: '',
        confirmButtonText: 'クリエイター一覧へ移動',
        confirmButtonColor: '#40BF6C',
        reverseButtons: true,
        allowOutsideClick: false
      })
      window.location.href = `/departments/${props.department.id}/creators`
    } catch (error) {
      data.isLoading = false
      await Swal.fire({
        icon: 'error',
        title: '登録に失敗しました',
        text: 'PANDA情報をご確認ください',
        confirmButtonText: 'OK',
        confirmButtonColor: '#40BF6C',
        reverseButtons: true,
        allowOutsideClick: false
      })
    }
  }
}
</script>

<template>
  <vue-element-loading :active="data.isLoading" is-full-screen />
  <button
    :class="[
      props.isDisabledButton
        ? 'disabled:opacity-25'
        : 'hover:border-transparent hover:bg-green-500 hover:text-white',
      'group flex items-center justify-center rounded-md border border-gray-500 bg-white py-2 pr-4 pl-3 text-sm font-medium text-gray-800 shadow-sm sm:w-auto'
    ]"
    :disabled="props.isDisabledButton"
    @click="submit"
  >
    週間スケジュール登録
  </button>
</template>
